import { render, staticRenderFns } from "./BadgeForm.vue?vue&type=template&id=5e4775b1&scoped=true&"
import script from "./BadgeForm.vue?vue&type=script&lang=js&"
export * from "./BadgeForm.vue?vue&type=script&lang=js&"
import style0 from "./BadgeForm.vue?vue&type=style&index=0&id=5e4775b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4775b1",
  null
  
)

export default component.exports